module.exports = __webpack_public_path__ + "assets/1albya-alt.a8b24eab.svg";